import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import Script from 'next/script';

import browser from '../../utils/browser';
import styles from './styles.module.sass';

const TRUSTPILOT_BOOTSTRAP_URL = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

const useTrustpilotWidget = () => {
  const widgetRef = useRef<HTMLDivElement | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [scriptReady, setScriptReady] = useState(false);

  useEffect(() => {
    const trustpilot = browser.getWindow().Trustpilot;
    if (trustpilot && widgetRef.current) {
      trustpilot.loadFromElement(widgetRef.current, true);
      setIsLoaded(true);
    }
  }, [scriptReady]);

  return { isLoaded, setScriptReady, widgetRef };
};

type TrustpilotWidgetProps = {
  onReady?: () => void;
};

const TrustpilotWidget = ({ onReady }: TrustpilotWidgetProps) => {
  const { isLoaded, setScriptReady, widgetRef } = useTrustpilotWidget();

  useEffect(() => {
    if (isLoaded && onReady) {
      onReady();
    }
  }, [isLoaded, onReady]);

  return (
    <>
      <Script src={TRUSTPILOT_BOOTSTRAP_URL} async onLoad={() => setScriptReady(true)} />
      <div
        ref={widgetRef}
        className={classNames('trustpilot-widget', styles.trustpilotWidget)}
        // Keep visibility inline so jsdom tests can assert it with toBeVisible; CSS module styles are not applied there, just class names, and we value testing user experience.
        style={{ visibility: isLoaded ? 'visible' : 'hidden' }}
        data-locale="en-AU"
        data-template-id="5419b6ffb0d04a076446a9af"
        data-businessunit-id="5d47b828b40197000193e1a4"
        data-style-width="100%"
        data-token="7fbfdbb6-a0f2-4abe-94a4-70b83299d7b6"
      >
        <a href="https://au.trustpilot.com/review/ahm.com.au" target="_blank" rel="noopener noreferrer">
          Trustpilot
        </a>
      </div>
    </>
  );
};

export default TrustpilotWidget;
